<template>
  <div>
    <div class="search">
      <span>采购人名称：</span>
      <Input type="text" v-model="searchCgrValue" style="width:200px;margin-right:10px;"></Input>
      <Button type="primary" @click="searchCgr(1)" size="small">搜索</Button>
      <Button type="primary" style="margin-left:5px" @click="addPVisible=true" size="small">新增</Button>
    </div>
    <Table :columns="cgrColumns" :data="cgrData" style="margin-top: 10px;"></Table>
    <Page :total="cgrTotal" ref="page" @on-change="pageChange" style="margin-top: 10px;" :page-size="8"></Page>
    <Modal v-model="addPVisible" title="新增采购人信息" width="900" :mask-closable="false" :transfer="false">
      <purchaser-card  @ok="addOK" :curPurchaserData="{}" :editSta="true" :id="0" :time="time"></purchaser-card>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import ajax from '@/lib/ajax'
import purchaserCard from "../purchaserCard.vue"

export default {
  name: 'selectCgr',
  components: {
    purchaserCard
  },
  data() {
    return {
      // 采购人
      cgrData: [],
      searchCgrValue: '',
      cgrColumns: [
        {
          title: '采购人',
          key: 'purchase',
        },
        {
          title: '联系地址',
          key: 'contactAddress',
        },
        {
          title: '采购人属性',
          key: 'purchaseSite',
          width: 100
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  on: {
                    click: () => {
                      this.cgrChoosed(params.row)
                    }
                  }
                }, '选择')
              ])
          }
        },
      ],
      cgrTotal: 0,
      addPVisible: false,
      time: new Date().getTime()
    }
  },
  methods: {
    async searchCgr(page) {
      let rep = await ajax.get('/api/services/app/ClPurchase/GetPaged', {
        params: {
          filter: `purchase.contains("${this.searchCgrValue}")`,
          sorting: 'firstTime desc',
          maxResultCount: 8,
          skipCount: (page - 1) * 8
        }
      })
      this.cgrData = rep.data.result.items
      this.cgrTotal = rep.data.result.totalCount
      if (page === 1) {
        this.$refs.page.currentPage = 1
      }
    },
    cgrChoosed(cgrInfo) {
      // 清空数据
      this.searchCgrValue = ''
      this.cgrData = []
      // 防止null出错
      for (let key in cgrInfo) {
        if (!cgrInfo[key]) {
          cgrInfo[key] = ''
        }
      }
      this.$emit('selected', cgrInfo)
    },
    pageChange(page) {
      this.searchCgr(page)
    },
    addOK (val) {
      this.addPVisible = val
    }
  }
}
</script>
